import { FILTER_JOB } from "@/constants/LocalStorageStoreKeys";
import { create } from "zustand";
import { persist, PersistOptions } from "zustand/middleware";

interface FilterJobState {
    job: string;
    businessUnit: string;
    experienceLevel: string;
    onSearchJobFocus: boolean;
}

interface FilterJobActions {
    setJob: (job: string) => void
    setBusinessUnit: (businessUnit: string) => void
    setExperienceLevel: (experience: string) => void
    setOnSearchJobFocus: (onSearchJobFocus: boolean) => void
}

type FilterJobStoreModel = FilterJobState & FilterJobActions

// eslint-disable-next-line
type FilterJobStore = (set: any) => FilterJobStoreModel

const initialState: FilterJobState = {
    job: "",
    businessUnit: "",
    experienceLevel: "",
    onSearchJobFocus: false,
}

const store: FilterJobStore = (set) => ({
    ...initialState,

    setJob: (job: string) => set((state) =>({ 
        ...state,
        job: job
    })),

    setBusinessUnit: (businessUnit: string) => set((state) =>({ 
        ...state,
        businessUnit: businessUnit
    })),

    setExperienceLevel: (experienceLevel: string) => set((state) =>({ 
        ...state,
        experienceLevel: experienceLevel
    })),

    setOnSearchJobFocus: (onSearchJobFocus: boolean) => set((state) =>({ 
        ...state,
        onSearchJobFocus: onSearchJobFocus
    })),
});

const persistOptions: PersistOptions<FilterJobStoreModel> =  {
    name: FILTER_JOB
}

const useFilterJob = create<FilterJobStoreModel>()(
    persist(store, persistOptions)
);

export default useFilterJob;